import { Fade, Slide } from "react-awesome-reveal"
import { Accordion } from "./Accordion"

export const FAQSection = ({ title, subtitle, items }) => {

    return (items?.length>0 && title && subtitle) && <div className="container py-5">
        <div className="row">
            <div className="col-12">
                <Slide delay={200} ><h4 className='text-primary  pb-2'>{title}</h4></Slide>
                <Slide delay={400} ><h2 className='text-primary pt-1'>{subtitle}</h2></Slide>
            </div>
            <div className="col-12 mt-3">
                <Fade triggerOnce={true}>
                    {items?.map((item, index) => {
                        return <Accordion
                            delay={1000 + (index * 100)}
                            title={item?.title}
                            children={`<p class='text-white pb-3'>${item?.content}</p>`}
                        />
                    })}
                </Fade>
            </div>
        </div>
    </div>
}